// Helper for wrapping text within a given width
export const wrapText = (text, maxWidth, fontSize = 18) => {
  const words = text.split(" ");
  const lines = [];
  let currentLine = [];

  // Approximate character width (adjust based on your font)
  const charWidth = fontSize * 0.6;
  const maxCharsPerLine = Math.floor(maxWidth / charWidth);

  for (const word of words) {
    const testLine = [...currentLine, word].join(" ");
    if (testLine.length <= maxCharsPerLine && currentLine.length < 3) {
      // Limit to 3 lines
      currentLine.push(word);
    } else {
      if (currentLine.length > 0) {
        lines.push(currentLine.join(" "));
        currentLine = [word];
      } else {
        // Word is too long, truncate it
        lines.push(word.substring(0, maxCharsPerLine - 3) + "...");
      }
    }
  }

  if (currentLine.length > 0) {
    lines.push(currentLine.join(" "));
  }

  // Limit to maximum 2-3 lines to keep roles readable
  return lines.slice(0, 2);
};

// Helper function to estimate text width
export const estimateTextWidth = (text, fontSize = 18) => {
  // Approximate character width (adjust based on your font)
  const charWidth = fontSize * 0.6;
  return text.length * charWidth;
};

// Helper function to calculate label bounds
export const getLabelBounds = (d) => {
  const labelText = d.label || "new role";
  const maxWidth = d.size.width - 10;
  const lines = wrapText(labelText, maxWidth, 18);
  const isBelow = d.labelPosition === "below";

  let yPosition;
  if (isBelow) {
    yPosition = d.size.height + (lines.length > 1 ? 20 : 15);
  } else {
    yPosition = lines.length > 1 ? -26 : -18;
  }

  // Calculate the actual width of the longest line
  const longestLine = lines.reduce(
    (longest, current) => (current.length > longest.length ? current : longest),
    ""
  );
  const textWidth = estimateTextWidth(longestLine, 18);

  // Calculate centered position
  const centerX = d.size.width / 2;
  const textStartX = centerX - textWidth / 2;
  const textEndX = centerX + textWidth / 2;

  return {
    y: yPosition,
    lineCount: lines.length,
    isBelow: isBelow,
    textWidth: textWidth,
    textStartX: textStartX,
    textEndX: textEndX,
    centerX: centerX,
  };
};
